import { createElement as e, useReducer as t, useMemo as n, useCallback as i } from "react";

import r from "react-ssr-prepass";

import { createClient as l, ssrExchange as s, dedupExchange as o, cacheExchange as a, fetchExchange as u, Provider as p } from "urql";

let f = null;

function resetClient() {
  f = null;
}

function initUrqlClient(e, t) {
  const n = "undefined" == typeof window;
  if (n || !f) {
    f = l({
      ...e,
      suspense: t && (n || e.suspense)
    });
    f.toJSON = () => null;
  }
  return f;
}

let c;

function withUrqlClient(l, f) {
  if (!f) {
    f = {};
  }
  return d => {
    const C = Boolean((d.getInitialProps || f.ssr) && !f.neverSuspend);
    const WithUrql = ({pageProps: r, urqlClient: q, urqlState: g, ...w}) => {
      const [m, h] = t((e => e + 1), 0);
      const v = r && r.urqlState || g;
      const y = n((() => {
        if (q && !m) {
          return q;
        }
        if (!c || "undefined" == typeof window) {
          c = s({
            initialState: v,
            isClient: !0,
            staleWhileRevalidate: "undefined" != typeof window ? f.staleWhileRevalidate : void 0
          });
        } else if (!m) {
          c.restoreData(v);
        }
        const e = l(c);
        if (!e.exchanges) {
          e.exchanges = [ o, a, c, u ];
        }
        return initUrqlClient(e, C);
      }), [ q, v, m ]);
      const S = i((() => {
        resetClient();
        c = s({
          initialState: void 0
        });
        h();
      }), []);
      return e(p, {
        value: y
      }, e(d, {
        ...w,
        pageProps: r,
        urqlClient: y,
        resetUrqlClient: S
      }));
    };
    WithUrql.displayName = `withUrqlClient(${d.displayName || d.name || "Component"})`;
    if (d.getLayout) {
      WithUrql.getLayout = d.getLayout;
    }
    if (d.getInitialProps || f.ssr) {
      WithUrql.getInitialProps = async t => {
        const n = t.AppTree;
        const i = !!t.Component;
        const p = i ? t.ctx : t;
        const c = s({
          initialState: void 0
        });
        const C = l(c, p);
        if (!C.exchanges) {
          C.exchanges = [ o, a, c, u ];
        }
        const q = initUrqlClient(C, !f.neverSuspend);
        if (q) {
          p.urqlClient = q;
        }
        let g = {};
        if (d.getInitialProps) {
          g = await d.getInitialProps(t);
          if (p.res && (p.res.writableEnded || p.res.finished)) {
            return {
              ...g,
              urqlClient: q
            };
          }
        }
        if ("undefined" != typeof window) {
          return {
            ...g,
            urqlClient: q
          };
        }
        const w = {
          ...g,
          urqlClient: q
        };
        const m = i ? w : {
          pageProps: w
        };
        if (!f.neverSuspend) {
          await r(e(n, m));
        }
        return {
          ...g,
          urqlState: c ? c.extractData() : void 0,
          urqlClient: q
        };
      };
    }
    return WithUrql;
  };
}

export { initUrqlClient, withUrqlClient };
//# sourceMappingURL=next-urql.es.js.map
